export const OrderImportStatus = {
	none: 0,
	created: 1,
	parsed: 2,
	validated: 3,
	completed: 4,
};

export const OrderImportStatusNames = {
	[OrderImportStatus.none]: "-",
	[OrderImportStatus.created]: "CREATED",
	[OrderImportStatus.parsed]: "PARSED",
	[OrderImportStatus.validated]: "VALIDATED",
	[OrderImportStatus.completed]: "COMPLETED",
};

export const OrderImportStatusColors = {
	[OrderImportStatus.none]: "#FFFFFF", // white
	[OrderImportStatus.created]: "#FFFFFF", // white
	[OrderImportStatus.parsed]: "#FFFF00", // light yellow
	[OrderImportStatus.validated]: "#FFFF00", // light yellow
    [OrderImportStatus.completed]: "#00AFF3", // blue
};
